import React from 'react';
import useBetsStore from '../stores/betsStore';
import useAuthStore from '../stores/authStore';
import StakeInput from './StakeInput';
import { useBets } from '../hooks/useBets';
import LoadingSpinner from './LoadingSpinner';
import toast from 'react-hot-toast';

export default function BetSlipSheet({ isOpen, onClose }) {
  const { selections, stake, removeSelection, setStake, clear, getPotentialReturn } = useBetsStore();
  const { balance } = useAuthStore();
  const { placeBetMutation } = useBets();
  const potentialReturn = getPotentialReturn();

  if (!isOpen) return null;

  const handlePlaceBet = () => {
    if (stake > balance) {
      toast.error('Saldo insuficiente');
      return;
    }
    placeBetMutation.mutate();
  };

  return (
    <div className="fixed inset-0 z-[7000] flex flex-col justify-end">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#1E1E1E] rounded-t-2xl p-4 max-h-[70vh] overflow-y-auto animate-slide-up">
        <div className="w-12 h-1 bg-[#333] rounded-full mx-auto mb-4" />
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-white font-bold text-lg">🎫 Bet Slip ({selections.length})</h2>
          <button onClick={clear} className="text-[#FF5252] text-sm">🗑️ Limpar</button>
        </div>
        {selections.map((sel) => (
          <div key={sel.market_id} className="flex justify-between items-center py-3 border-b border-[#333]">
            <div>
              <div className="text-white text-sm font-medium">{sel.event_name}</div>
              <div className="text-[#00E676] font-mono text-sm font-bold">{sel.selection} @ {sel.odds.toFixed(2)}</div>
            </div>
            <button onClick={() => removeSelection(sel.market_id)} className="text-[#FF5252] text-lg">✕</button>
          </div>
        ))}
        <div className="mt-4">
          <StakeInput value={stake} onChange={setStake} balance={balance} />
          <div className="flex justify-between items-center mt-4">
            <span className="text-[#B0B0B0]">Retorno potencial:</span>
            <span className="text-[#00E676] font-mono text-xl font-bold">{potentialReturn.toFixed(2)} USDT</span>
          </div>
          <button
            onClick={handlePlaceBet}
            disabled={placeBetMutation.isPending}
            className="mt-4 w-full h-14 bg-[#00E676] text-[#121212] font-bold rounded-xl active:scale-[0.98] transition disabled:opacity-50 flex items-center justify-center"
          >
            {placeBetMutation.isPending ? <LoadingSpinner size="sm" /> : '🚀 APOSTAR AGORA'}
          </button>
        </div>
      </div>
    </div>
  );
}
